<template>
  <div class="step-box">
    <div class="step">
      <el-steps
        :active="stage * 1 - 1"
        align-center
      >
        <template v-for="(step, stepIndex) in steps">
          <el-step :key="step.id">
            <template slot="icon">
              <i class="el-icon-check" />
              <span class="step-num">{{ stepIndex + 1 }}</span>
              <span class="step-num active">{{ stepIndex + 1 }}</span>
            </template>
            <template slot="title">
              <p
                class="title"
                v-text="step.name"
              />
            </template>
          </el-step>
        </template>
      </el-steps>
    </div>
  </div>
</template>

<script>
import IconWaiting from '@/assets/image/icon/waiting-icon.png';

export default {
  name: 'AddAderStep',
  props: {
    stage: {
      type: Number,
      required: true,
      default: 1,
    },

    steps: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  data: () => ({
    iconWaiting: IconWaiting,
  }),
  methods: {},
};
</script>

<style lang="less" scoped>
.step-box {
  .step {
    /deep/ .el-step__icon.is-text {
      border: 0;
    }

    /deep/ .el-step__line {
      background: transparent;
      left: 70%;
      right: -30%;
      .el-step__line-inner {
        border-style: dashed;
        border-width: 1px !important;
        width: 100% !important;
      }
    }
    /deep/ .is-finish {
      .el-step__line-inner {
        border-color: #2f9eff;
      }
      .el-step__icon.is-text {
        border: 1px solid;
      }
      .step-num {
        display: none;
      }
      .step-num.active {
        display: none;
      }
      .el-icon-check {
        display: block;
      }
      .title {
        color: rgba(47, 158, 255, 1);
      }
    }
    /deep/ .is-process {
      .el-step__line-inner {
        border-color: #ddd;
      }
      border-color: #22affb;
      .step-num {
        display: none;
      }
      .step-num.active {
        display: block;
      }
      .el-icon-check {
        display: none;
      }
      .title {
        color: rgba(47, 158, 255, 1);
      }
      .ops-btn {
        display: block;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
      }
    }
    /deep/ .is-wait {
      .el-step__line-inner {
        border-color: #ddd;
      }
      border-color: #f3f5f5;
      .step-num {
        display: block;
      }
      .step-num.active {
        display: none;
      }
      .el-icon-check {
        display: none;
      }
      .title {
        color: #909399;
      }
    }

    .step-num {
      border-radius: 50%;
      display: block;
      width: 100%;
      color: #909399;
      background: #f3f5f5;
      width: 24px;
      line-height: 24px;
      height: 24px;

      &.active {
        color: #fff;
        background: linear-gradient(
          180deg,
          rgba(113, 198, 255, 1) 0%,
          rgba(47, 158, 255, 1) 100%
        );
      }
    }

    .title {
      font-size: 14px;
      font-weight: 500;
      color: rgba(47, 158, 255, 1);
      line-height: 20px;
      padding-top: 3px;
    }

    .ops-btn {
      display: none;
    }

    .status-btn-icon {
      display: inline-block;
      padding: 6px 20px;
      border-radius: 4px;
      text-align: center;
      font-size: 12px;
      font-weight: 500;
      color: #f6b423;
      white-space: nowrap;
      line-height: 24px;

      img {
        position: relative;
        width: 16px;
        top: 3px;
        margin-right: 6px;
      }
    }
  }
}
</style>
